<template>
    <div>
        <!-- <input
            :id="id"
            :placeholder="placeholder"
            :value="value"
            @input="$emit('input', $event.target.value)"
            class="search-input"
        > -->
        <v-icon class="mdi mdi-magnify search-icon"/>
        <input
            :id="id"
            :placeholder="placeholder"
            :value="searchValue"
            @input="handleSearch($event.target.value)"
            class="search-input"
        >
        <!-- <TextButton  @click="handleSearch(searchValue)" buttonText="검색" IconBackgroundColor="black"  buttonClass="BlackButton" class="ml-2"/> -->
    </div>
</template>

<script>
import TextButton from '@/components/ui/button/TextButton.vue';

export default {
    components: {
        TextButton,
    },
    name:'SearchTextfield',
    props: {
        id: String,
        placeholder: {
        type: String,
        default: '동영상 제목 또는 태그로 동영상 찾기'
        },
        value: String,
        buttonText: {
        type: String,
        default: 'Search',
        },
        search: {
        type: String,
        default: '',
        },
    },  
    methods: {
        handleSearch(event) {
            this.searchValue = event;
            this.$store.dispatch('asset/updateSearch', this.searchValue);
        }
    },
    data() {
        return {
            searchValue: this.search 
        };
    },
    created(){
        
    },
};
</script>

<style scoped>
.search-input {
    width: 70%;
    height: 36px;
    padding: 8px;
    margin-bottom: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    background: #fff;
    padding-left: 36px;
}
input:focus  {
    outline: none;
    border: 1px solid #999;
}

.search-icon {
    position: absolute;
    margin-left: 10px;
    margin-top: 6px;
    color: #aaa;
}
</style>